// extracted by mini-css-extract-plugin
export var accordion = "_dz-0";
export var chevron = "_dz-3";
export var closed = "_dz-2";
export var content = "_dz-4";
export var open = "_dz-1";
export var rotate = "_dz-5";